// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"addPassToInvite_wrapper__2tG87","header":"addPassToInvite_header__3nCHu","loadContainer":"addPassToInvite_loadContainer__17lmD"};